export default __webpack_public_path__ + "img/main.connect-calendar@2x.925c9d06.png";